module.exports = __webpack_public_path__ + "static/badge-eco-conscious-150x150-85b48dc0235260ea95cf432d42933dad.png";